import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
import { Question } from '../models/question';

export type PointsModel = {
    current: number,
    max: number
};

interface GameContextData {
    questions: Question[];
    points: PointsModel;
    updatePoints: (points: number) => void;
    reset: () => void;
}

interface GameProviderProps {
    children: ReactNode;
}

const GameContext = createContext<GameContextData>({} as GameContextData);

export function GameProvider({ children }: GameProviderProps) {

    const data = useRef<Question[]>([]);
    const [questions, setQuestions] = useState<Question[]>([]);
    const [points, setPoints] = useState<PointsModel>({
        current: 0,
        max: 0
    });

    useEffect(() => {
        fetch('quizz.json')
            .then(res => res.json())
            .then(onDataSuccess);
    }, []);

    const onDataSuccess = (json: Question[]) => {
        json.sort(() => Math.random() - 0.5)
        data.current = json.slice(0, 15);
        setQuestions(data.current);
        setPoints({
            current: 0,
            max: data.current.length * 10
        });
    }

    const reset = () => setPoints({
        current: 0,
        max: data.current.length * 10
    });

    const updatePoints = (currentPoints: number) => {
        setPoints(p => ({ ...p, current: p.current + currentPoints }));
    }

    return (
        <GameContext.Provider value={{ questions, points, updatePoints, reset}}>
            {children}
        </GameContext.Provider>
    )
}

export function useGame() {
    const context = useContext(GameContext);
    return context;
}